import { render, staticRenderFns } from "./OuterCustomerManagementDetail.vue?vue&type=template&id=338c709a&scoped=true"
import script from "./OuterCustomerManagementDetail.vue?vue&type=script&lang=js"
export * from "./OuterCustomerManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./OuterCustomerManagementDetail.vue?vue&type=style&index=0&id=338c709a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c709a",
  null
  
)

export default component.exports